import { settings } from "./config/frontend";
import { SessionStorageCache } from "./sessionStorageCache";

/**
 * Auth0Provider configuration, kept out of index.tsx so it can be asserted on.
 *
 * `cache` intentionally replaces `cacheLocation`: the SDK ignores `cacheLocation`
 * when both are supplied, and warns about it. See SessionStorageCache for why the
 * default in-memory cache is not sufficient here.
 */
export const authProviderOptions = {
  domain: settings.auth0ApiDomain,
  clientId: settings.auth0ClientId,
  authorizationParams: {
    redirect_uri: window.location.origin,
    audience: "https://delorean-corporate-portal",
  },
  cache: new SessionStorageCache(),
  useRefreshTokens: true,
  useRefreshTokensFallback: true,
};
